import { render, staticRenderFns } from "./StepAdditions.vue?vue&type=template&id=147ecb1d&"
import script from "./StepAdditions.vue?vue&type=script&lang=js&"
export * from "./StepAdditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports